/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import useAuth from '../../../Hooks/useAuth';
import {
  AccountForm, Feedbacktext, InputLabel, InputWrapper, PopupInput, UpdateButton,
} from './updateAccountPopupElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';

const ChangePasswordPopup = ({ setOpen }) => {
  const { auth, setAuth } = useAuth();
  const axiosPrivate = useAxiosPrivate();

  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [state, setState] = useState({
    phone: auth.phone ? auth.phone : '',
    company: auth.company ? auth.company : '',
    social: auth.social ? auth.social : '',
    handle: auth.handle ? auth.handle : '',
  });

  const handleInput = (e) => {
    const input = e.currentTarget.name;
    const { value } = e.currentTarget;

    setState((prev) => ({ ...prev, [input]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (state.phone === auth.phone && state.company === auth.company
      && state.social === auth.social && state.handle === auth.handle) {
      return setFeedback('No changes made');
    }

    setLoading(true);

    axiosPrivate.post(
      '/updateAccount',
      JSON.stringify({
        company: state.company,
        phone: state.phone,
        social: state.social,
        handle: state.handle,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status === 'error') {
        setFeedback(res.data.message ? res.data.message : 'Something went wrong');
        setLoading(false);
      } else {
        setAuth((prev) => ({
          ...prev,
          phone: state.phone,
          company: state.company,
          handle: state.handle,
          social: state.social,
        }));
        setFeedback(res.data.message);
        setTimeout(() => {
          setLoading(false);
          setOpen(false);
          setFeedback('');
        }, 1000);
      }
    }).catch((error) => {
      setLoading(false);
      setFeedback(error.response.data.message ? error.response.data.message : 'Something went wrong');
    });
  };

  // Error handling
  useEffect(() => {
    setFeedback('');
  }, [state]);

  return (
    <AccountForm onSubmit={handleSubmit}>
      <InputWrapper>
        <InputLabel htmlFor="phone">Phone:</InputLabel>
        <PopupInput
          value={state.phone}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="tel"
          name="phone"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="comapny">Company:</InputLabel>
        <PopupInput
          value={state.company}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="company"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="social">Social media:</InputLabel>
        <PopupInput
          value={state.social}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="social"
        />
      </InputWrapper>
      <InputWrapper>
        <InputLabel htmlFor="handle">Handle:</InputLabel>
        <PopupInput
          value={state.handle}
          autoComplete="off"
          onChange={handleInput}
          aria-describedby="uidnote"
          type="text"
          name="handle"
        />
      </InputWrapper>
      <UpdateButton disabled={loading} type="submit">{loading ? 'Updating' : 'Update'}</UpdateButton>
      {feedback && <Feedbacktext>{feedback}</Feedbacktext>}
    </AccountForm>
  );
};

export default ChangePasswordPopup;
